<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon v-on="on"
              :class="iconClass"
              :small="small" :left="left" :right="right" :color="iconColor">
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>

</template>

<script>
import Vue from 'vue';
import { formatarContatoAbertura } from '@/utils/log-acesso-utils';

export default {
  props: {
    registro: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
    left: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    tipoRegistroTooltip: {
      type: String,
      default: 'solicitação',
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    icon() {
      return this.registro.abertaEm ? 'mdi-check-all' : 'mdi-check';
    },
    iconColor() {
      return this.registro.abertaEm ? 'primary' : '';
    },
    tooltipText() {
      if (!this.registro.abertaEm) {
        return `A ${this.tipoRegistroTooltip} ainda não foi aberta pelo fornecedor`;
      }
      const abertura = Vue.filter('date')(this.registro.abertaEm, true);
      const contato = formatarContatoAbertura(this.registro.abertoPor);
      return `Aberto em ${abertura} por ${contato}`;
    },
  },
};
</script>
